import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';
import { IPortfolioTopHeroesComponentsList } from 'api/queries/getProjectScoreCardsSummary';
import { QueryKeys } from 'api/queryKeys';

export interface QueryResponse {
    componentsList: IPortfolioTopHeroesComponentsList;
    info?: IToolTip;
    name: string;
    numOfItems: number;
}

export const useQueryPortfolioTopHeroes = (params, endpoint?: string) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['portfolioTopHeroes', params],
        queryFn: () => queryFn(params, endpoint),
    });
};
